export default "__VITE_ASSET__d7f2d025__"